import {
  successToast as baseSuccessToast,
  warningToast as baseWarningToast,
  errorToast as baseErrorToast,
  infoToast as baseInfoToast
} from 'irmlib/containers'
import { toastTop, appHeaderHeight } from '../components/AppControl/constants'
import { userRoleAdmin, userRoleSuperUser, userRoleSupervisor, userRoleUser, userTypes, defaultDateFormat, defaultDateFormat2 } from './constants'
import { getUserRole, clearReduxGlobal } from '../redux/global'
import * as gdeTransactions from '../services/firestore/gdeTransactions'
import { updateLogin } from '../services/firestore/login'
import { auth } from '../utils/firestore'
import { clearCache } from '../services/firestore/cache'
import * as constants from '../irmlib/src/common/constants'
import moment from 'moment'
// import { defaultDateFormat } from '../common/constants'
import { t } from 'i18next'
import * as appConstants from '../../src/services/common/appConstants'
// import { jobId, defaultDateFormat, altKeyCode } from '../../../common/constants'

const standardToastTop = `${parseInt(toastTop) + parseInt(appHeaderHeight)}px`
// let user
export const successToast = ({ message, title, autoHideDuration, isBlocking, closeIcon }) => {
  baseSuccessToast({ message, title, autoHideDuration, isBlocking, top: standardToastTop, closeIcon })
}

export const warningToast = ({ message, title, autoHideDuration, isBlocking, closeIcon }) => {
  baseWarningToast({ message, title, autoHideDuration, isBlocking, top: standardToastTop, closeIcon })
}

export const errorToast = ({ message, title, autoHideDuration, isBlocking, closeIcon }) => {
  baseErrorToast({ message, title, autoHideDuration, isBlocking, top: standardToastTop, closeIcon })
}

export const infoToast = ({ message, title, autoHideDuration, isBlocking, closeIcon }) => {
  baseInfoToast({ message, title, autoHideDuration, isBlocking, top: standardToastTop, closeIcon })
}

export const isAdmin = () =>
  getUserRole() === userRoleAdmin

export const isSupervisor = () =>
  getUserRole() === userRoleSupervisor

export const isDataEntryUser = () =>
  getUserRole() === userRoleUser

export const isSuperUser = () =>
  getUserRole() === userRoleSuperUser

export const doLogout = async () => {
  await updateLogin()
  clearReduxGlobal()
  clearCache()
  sessionStorage.clear()
  auth.signOut()
}

export const getValidationText = (field) => {
  if (field.format === 'date') {
    // MMDDyyyy
    return /^0?[1-9]|1[012]?:19|20\\d\\d[12][0-9]|3[01]|0?[1-9]/
  } else {
    return ''
  }
}

// {
//   "customOrder": 3,
//   "customFormat": "",
//   "doNotDuplicate": false,
//   "order": 4,
//   "customLength": 12,
//   "isRequired": false,
//   "actualLength": 12,
//   "verify": true,
//   "isSelected": true,
//   "defaultValue": "",
//   "format": "",
//   "customName": "departmentId",
//   "name": "departmentId"
// }

const RequiredErrorcode = 'dataEntry.requiredErrorcode'
const lengthExceeded = 'dataEntry.lengthExceeded'
const duplicateValue = 'dataEntry.duplicateValue'
const invalidDateFormatMessage = 'dataEntry.invalidDateFormat'
const invalidFormatMessage = 'dataEntry.invalidFormat'
const nonUtcValues = 'dataEntry.nonUtcValues'
const invalidFormatGeneric = 'dataEntry.invalidFormatGeneric'
const doubleQuoteRestrict = 'dataEntry.doubleQuoteRestrict'
const fromDateToDateError = 'dataEntry.fromDateToDateError'

export const dateValidatePattern = {
  'MM/DD/YYYY': '^((((0[13578]|1[02])[/](0[1-9]|1[0-9]|2[0-9]|3[01]))|((0[469]|11)[/](0[1-9]|1[0-9]|2[0-9]|3[0]))|((02)([/](0[1-9]|1[0-9]|2[0-9]))))[/]([1-9]{1}[0-9]{3}))$',
  'DD/MM/YYYY': '^((((0[1-9]|1[0-9]|2[0-9]|3[01])[/](0[13578]|1[02]))|((0[1-9]|1[0-9]|2[0-9]|3[0])[/](0[469]|11))|((0[1-9]|1[0-9]|2[0-9])([/])(02)))[/]([1-9]{1}[0-9]{3}))$',  
  'UTF/CHARACTER': '^([^À-ÿ])*$',
  'UTF/CHARACTER_EURO': '^([!-~áÁéÉíÍñÑóÓúÚüÜÖŐŰ ])*$'
}

export const formatValue = (keyCode, regExPattern, value) => {
  const maskedValue = value.replace(/[0-9a-zA-Z]/g, 'X')
  if (regExPattern.match(maskedValue)) {
    const lengthOfValue = value.length
    const splittedRegExPattern = regExPattern.split('')
    const splittedMaskedValue = maskedValue.split('')
    if (keyCode !== 8 && keyCode !== 46 && value.length !== regExPattern.length) {
      if (splittedRegExPattern[lengthOfValue] !== 'X') {
        // eslint-disable-next-line
        return value + '' + splittedRegExPattern[lengthOfValue]
      }
    } else if (keyCode === 8 && splittedMaskedValue[lengthOfValue - 1] !== 'X') {
      return value.slice(0, lengthOfValue - 1)
    }
  }
}

export const validarCPF = (cpf) => {
  cpf = cpf.replace(/\D/g, '')
  if (cpf.length !== 11) {
    return false
  }

  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i)
  }

  let firsNumber = 11 - (sum % 11)
  if (firsNumber > 9) {
    firsNumber = 0
  }

  if (firsNumber !== parseInt(cpf.charAt(9))) {
    return false
  }

  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i)
  }

  let secondNumber = 11 - (sum % 11)
  if (secondNumber > 9) {
    secondNumber = 0
  }

  if (secondNumber !== parseInt(cpf.charAt(10))) {
    return false
  }
  return true
}

export const validarRUTPersona = (rut) => {
  rut = rut.replace(/[^0-9kK]/g, '')
  if (rut.length < 2) {
    return false
  }

  const number = rut.slice(0, -1)
  const dv = rut.slice(-1).toLowerCase()
  let sum = 0
  let multiplier = 2
  for (let i = number.length - 1; i >= 0; i--) {
    sum += parseInt(number.charAt(i)) * multiplier
    multiplier = (multiplier % 7) + 2
  }
  let numberValidateExpected = (11 - (sum % 11)).toString()
  if (numberValidateExpected === '10') {
    numberValidateExpected = 'k'
  }

  return dv === numberValidateExpected
}
// eslint-disable-next-line
function validarRUTEmpresa(rut) {
  rut = rut.replace(/[^0-9a-zA-Z]/g, '')
  if (rut.length < 1) {
    return false
  }

  const number = rut.slice(0, -1)
  const dv = rut.slice(-1).toLowerCase()
  let sum = 0
  let multiplier = 2
  for (let i = number.length - 1; i >= 0; i--) {
    sum += parseInt(number.charAt(i), 36) * multiplier
    multiplier++
    if (multiplier > 7) {
      multiplier = 2
    }
  }

  let numberValidateExpected = (11 - (sum % 11)).toString()
  if (numberValidateExpected === '10') {
    numberValidateExpected = 'k'
  }
  return dv === numberValidateExpected
}

export const leapYearValidation = (format, value) => {
  const dateValueArray = value.split('/')
  const dateFormatArray = format.split('/')
  const yearValue = dateValueArray[dateFormatArray.indexOf('YYYY')]
  const monthValue = dateValueArray[dateFormatArray.indexOf('MM')]
  const dateValue = dateValueArray[dateFormatArray.indexOf('DD')]
  // a year which is not divisible 4 & month is february, date should be less than equal to 28
  if (monthValue === '02' && dateValue === '29' && yearValue % 4 !== 0) {
    return false
  } else {
    return true
  }
}

export const validateFormat = (format, pattern = '', value, skpInstance, regexFormat) => {
  let regex
  let isDate = false
  let utcValidate = true
  let isValidFormat = true
  const definedDateFormat = Object.keys(dateValidatePattern)
  if (appConstants.countrySpecificFormats.includes(format)) {
    if (format === 'CPF' && !validarCPF(value)) {
      isValidFormat = false
    } else if (format === 'RUT' && !validarRUTPersona(value) && !validarRUTEmpresa(value)) {
      isValidFormat = false
    }
  } else {
    if (format === definedDateFormat[0] || format === definedDateFormat[1]) {
      if (!leapYearValidation(format, value)) {
        isValidFormat = false
      } else {
        regex = new RegExp(dateValidatePattern[format])
        isDate = true
        isValidFormat = regex.test(value)
      }
    } else if (format || pattern) {
      regex = new RegExp(pattern)
      isValidFormat = regex.test(value)
    }
    if (format === '' && isValidFormat) {
      if (regexFormat !== undefined || '') {
        regex = new RegExp(regexFormat)
      } else if (skpInstance === 'EURO') {
        regex = new RegExp(dateValidatePattern['UTF/CHARACTER_EURO'])
      } else {
        regex = new RegExp(dateValidatePattern['UTF/CHARACTER'])
      }
      // if (skpInstance === 'EURO') {
      //   regex = new RegExp(dateValidatePattern['UTF/CHARACTER_EURO'])
      // } else {
      //   regex = new RegExp(dateValidatePattern['UTF/CHARACTER'])
      // }
      // regex = new RegExp(regexFormat)
      isValidFormat = regex.test(value)
      if (!isValidFormat) {
        utcValidate = false
      }
    }
  }
  return { isDate, isValidFormat, utcValidate }
}

export const validateField = async (folderName, currentFieldVal, currentFieldKey, allTempList, wmsCode, currentFormData) => {
  const fieldDetails = allTempList[currentFieldKey]
  const errors = []

  if (fieldDetails) {
    const formatOfField = fieldDetails?.format
    const maxLength = fieldDetails?.length
    const definedDatesFormat = Object.keys(dateValidatePattern)
    const currentFieldId = fieldDetails?.fieldId?.toLowerCase()

    if (formatOfField && definedDatesFormat.includes(formatOfField)) {
      const regex = new RegExp(dateValidatePattern[formatOfField])
      const isDateValid = regex.test(currentFieldVal)
      const isLeapInvalid = leapYearValidation(formatOfField, currentFieldVal)

      if (!isLeapInvalid || !isDateValid) {
        errors.push({ field: currentFieldKey, message: 'Invalid Date format.Expected ' + formatOfField })
      } else if (wmsCode === 'ONEIL' && (currentFieldId === 'fromdate' || currentFieldId === 'todate')) {
        let fromDateValue = ''
        let toDateValue = ''
        let fromDateKey
        let toDateKey

        const parseDate = (dateString) => {
          if (!dateString) return null
          const [a, b, c] = dateString.split('/').map(Number)
          if (!a || !b || !c) return null
          if (a > 12) return new Date(c, b - 1, a)
          if (b > 12) return new Date(c, a - 1, b)
          return new Date(c, b - 1, a)
        }

        Object.entries(allTempList).forEach(([key, details]) => {
          if (details?.fieldId?.toLowerCase() === 'fromdate') {
            fromDateKey = key
          } else if (details?.fieldId?.toLowerCase() === 'todate') {
            toDateKey = key
          }
        })

        fromDateValue = currentFormData[folderName][fromDateKey]
        toDateValue = currentFormData[folderName][toDateKey]
        const fromDate = currentFieldId === 'fromdate' ? currentFieldVal : fromDateValue
        const toDate = currentFieldId === 'todate' ? currentFieldVal : toDateValue

        if (fromDate && toDate) {
          const from = parseDate(fromDate)
          const to = parseDate(toDate)
          if (from && to && from > to) {
            errors.push(
              { field: currentFieldKey, message: t('dataEntry.fromDateToDateError') }
            )
          } else {
            errors.push({ field: currentFieldKey, message: '' })
          }
        }
      }
    } else if (!formatOfField && maxLength) {
      if (currentFieldVal?.length > maxLength) {
        errors.push({ field: currentFieldKey, message: 'Exceeds max length (' + maxLength + '). Got ' + currentFieldVal.length })
      } else if (wmsCode === 'ONEIL' && (currentFieldId === 'sequenceend' || currentFieldId === 'sequencebegin')) {
        let seqBeginValue = ''
        let seqEndValue = ''
        let seqBeginKey
        let seqEndKey

        Object.entries(allTempList).forEach(([key, details]) => {
          if (details?.fieldId?.toLowerCase() === 'sequencebegin') {
            seqBeginKey = key
          } else if (details?.fieldId?.toLowerCase() === 'sequenceend') {
            seqEndKey = key
          }
        })

        seqBeginValue = currentFormData[folderName][seqBeginKey]
        seqEndValue = currentFormData[folderName][seqEndKey]
        const seqBegin = currentFieldId === 'sequencebegin' ? currentFieldVal : seqBeginValue
        const seqEnding = currentFieldId === 'sequenceend' ? currentFieldVal : seqEndValue
        if (isNaN(Number(currentFieldVal))) {
          errors.push(
            { field: currentFieldKey, message: t('dataEntry.navigation.invalidNumber') }
          )
        } else if (seqBegin?.length && seqEnding?.length) {
          const seqBeg = Number(seqBegin)
          const seqEnd = Number(seqEnding)
          if (seqBeg >= seqEnd) {
            errors.push(
              { field: currentFieldKey, message: t('smartCatalog.seqError') }
            )
          } else {
            errors.push({ field: currentFieldKey, message: '' })
          }
        }
      }
    } else {
      errors.push({ field: currentFieldKey, message: '' })
    }
  }
  return errors?.length ? errors[0]?.message : ''
}

export const getValidation = async (templateFields, arrRef, jobId, fileList, arrRefs, skpInstance, regexFormat) => {
  const currentFieldName = arrRef.current?.getFormTemplate().fieldKey
  const fromToDateFieldArray = ['fromDate', 'fromDate_verify', 'toDate', 'toDate_verify']
  let isVerificationPopUp = false
  let verificationPopUpFieldName = false
  if (currentFieldName === undefined && fromToDateFieldArray.includes(templateFields.name)) {
    isVerificationPopUp = true
    verificationPopUpFieldName = templateFields.name
  }

  if (fromToDateFieldArray.includes(currentFieldName) || isVerificationPopUp) {
    let fromDateValue
    let fromDateValueV
    let fromDateValueIndex
    let fromDateValueIndexV
    let toDateValue
    let toDateValueV
    let toDateValueIndex
    let toDateValueIndexV
    for (let i = 0; i < arrRefs.length; i++) {
      const fieldName = arrRefs[i]?.current?.getFormTemplate().fieldKey
      if (fieldName === 'fromDate') {
        fromDateValue = arrRefs[i]?.current?.getValue()
        fromDateValue = moment(fromDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        fromDateValueIndex = i
      }
  
      if (fieldName === 'toDate') {
        toDateValue = arrRefs[i]?.current?.getValue()
        toDateValue = moment(toDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        toDateValueIndex = i
      }

      if (fieldName === 'fromDate_verify') {
        fromDateValueV = arrRefs[i]?.current?.getValue()
        fromDateValueV = moment(fromDateValueV, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        fromDateValueIndexV = i
      }
  
      if (fieldName === 'toDate_verify') {
        toDateValueV = arrRefs[i]?.current?.getValue()
        toDateValueV = moment(toDateValueV, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        toDateValueIndexV = i
      }
    }

    arrRefs[fromDateValueIndex]?.current?.setErrorMsg()
    arrRefs[toDateValueIndex]?.current?.setErrorMsg()
    if (fromDateValue && toDateValue) {
      if (new Date(fromDateValue).getTime() > new Date(toDateValue).getTime()) {
        arrRefs[fromDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        arrRefs[toDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        return [fromDateToDateError]
      }
    }

    arrRefs[fromDateValueIndexV]?.current?.setErrorMsg()
    arrRefs[toDateValueIndexV]?.current?.setErrorMsg()
    if (fromDateValueV && toDateValueV) {
      if (new Date(fromDateValueV).getTime() > new Date(toDateValueV).getTime()) {
        arrRefs[fromDateValueIndexV]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        arrRefs[toDateValueIndexV]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        return [fromDateToDateError]
      }
    }

    if (isVerificationPopUp && verificationPopUpFieldName) {
      let dateValue
      if (verificationPopUpFieldName === 'fromDate' && arrRef.current.getValue() && toDateValue) {
        dateValue = moment(arrRef.current.getValue(), arrRef?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        if (new Date(dateValue).getTime() > new Date(toDateValue).getTime()) {
          arrRef?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          return [fromDateToDateError]
        }
      } else if (verificationPopUpFieldName === 'toDate' && arrRef.current.getValue() && fromDateValue) {
        dateValue = moment(arrRef.current.getValue(), arrRef?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        if (new Date(fromDateValue).getTime() > new Date(dateValue).getTime()) {
          arrRef?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          return [fromDateToDateError]
        }
      }
    }
  }

  const value = arrRef.current.getValue()

  // required field validation
  if (templateFields.isRequired && !value) {
    return [RequiredErrorcode]
  }
  // length validation
  if (value && value.length > templateFields.customLength) {
    return [lengthExceeded]
  }

  if (value && value.search('"') >= 0) {
    return [doubleQuoteRestrict]
  }

  // do not duplicate validation
  if (templateFields.doNotDuplicate) {
    let errMsg
    const skpBoxId = fileList[0]?.skpBoxId
    fileList.forEach((file) => {
      if (file[templateFields.name] === value) {
        errMsg = duplicateValue
        return [errMsg]
      }
    })
    if (errMsg === undefined) {
      const files = await gdeTransactions.getFilesforDoNotDuplicate(jobId, templateFields.name, value)
      if (files.docs.length > 0) {
        if (skpBoxId !== undefined) {
          let hasduplicate = false
          files.forEach((file) => {
            if (file.data().fileInfo.skpBoxId !== skpBoxId) {
              hasduplicate = true
              return [duplicateValue]
            }
          })
          if (hasduplicate) {
            return [duplicateValue]
          }
        } else {
          return [duplicateValue]
        }
      }
    } else {
      return [errMsg]
    }
  }

  // validate field format
  if (value) {
    const formatRequired = templateFields.customFormat
    const { isDate, isValidFormat, utcValidate } = validateFormat(formatRequired, templateFields?.regExPattern, value, skpInstance, regexFormat)
    if (!isValidFormat) {
      if (isDate) {
        return [t(invalidDateFormatMessage, { format: formatRequired }), true]
      } else {
        if (!utcValidate && formatRequired) {
          return [t(nonUtcValues, { format: formatRequired }), true]
        } else if (formatRequired) {
          return [t(invalidFormatMessage, { format: formatRequired }), true]
        } else {
          return [t(invalidFormatGeneric), true]
        }
      }
    }
  }
  return [undefined]
}

export const getValidations = (templateFields, arrRef, jobId, fileList, skpInstance, regexFormat) => {
  const value = arrRef?.current?.getValue() === undefined ? arrRef[templateFields.name] : arrRef.current.getValue()
  // required field validation
  if (templateFields.isRequired && !value) {
    return [t(RequiredErrorcode)]
  }
  // length validation
  if (value && value.length > templateFields.customLength) {
    return [t(lengthExceeded)]
  } if (value && value.search('"') >= 0) {
    return [t(doubleQuoteRestrict)]
  }
  // validate field format
  if (value) {
    const formatRequired = templateFields.customFormat
    const { isDate, isValidFormat, utcValidate } = validateFormat(formatRequired, templateFields?.regExPattern, value, skpInstance, regexFormat)
    if (!isValidFormat) {
      if (isDate) {
        return [t(invalidDateFormatMessage, { format: formatRequired }), true]
      } else {
        if (!utcValidate && formatRequired) {
          return [t(nonUtcValues, { format: formatRequired }), true]
        } else if (formatRequired) {
          return [t(invalidFormatMessage, { format: formatRequired }), true]
        } else {
          return [t(invalidFormatGeneric), true]
        }
      }
    }
  }
  // do not duplicate validation
  if (arrRef?.current?.getValue() === undefined) {
    if (templateFields.doNotDuplicate) {
      let duplicateFound = false
      const rowKey = arrRef.fileId ?? arrRef.skpBoxId ?? arrRef.boxId ?? arrRef.SKP_Box_ID
      fileList?.forEach((file) => {
        const fileKey = file.fileId ?? file.skpBoxId ?? file.boxId ?? file.SKP_Box_ID
        if (file[templateFields.name] === value && fileKey !== rowKey) {
          duplicateFound = true
        }
      })

      if (duplicateFound) {
        return [t(duplicateValue)]
      }
    }
  }

  return [undefined]
}

export const getUserType = (jobUser, loggedInUser, boxData = {}, addNewFileByVerifier) => {
  let userType = ''
  if (!addNewFileByVerifier) {
    const { dataEntryUser, verificationUser } = boxData
    if (boxData !== undefined && Object.keys(boxData).length > 0) {
      if (loggedInUser === dataEntryUser && loggedInUser === verificationUser) {
        userType = userTypes.DATAENTRY_AND_VERIFY_USER
      } else if (loggedInUser === dataEntryUser) {
        userType = userTypes.DATAENTRY_USER
      } else if (loggedInUser === verificationUser) {
        userType = userTypes.VERIFICATION_USER
      }
    } else {
      if (jobUser !== undefined && Object.keys(jobUser).length > 0) {
        if (jobUser.verifyUser) {
          if (jobUser.verifyUser === loggedInUser) {
            userType = userTypes.DATAENTRY_AND_VERIFY_USER
          } else {
            userType = userTypes.DATAENTRY_USER
          }
        } else {
          if (jobUser.jobCategory.length === 1 && jobUser.jobCategory[0] === 'Data Entry User') {
            userType = userTypes.DATAENTRY_USER
          } else {
            userType = userTypes.VERIFICATION_USER
          }
        }
      }
    }
  } else if (addNewFileByVerifier) {
    userType = userTypes.DATAENTRY_USER
  }

  return userType
}

export const getJobStatusToBeupdated = async (jobId, userType, isVerifyRequired, user, qualityCheck) => {
  let status
  const jobData = await gdeTransactions.getJobById(jobId)
  const isQualityCheckRequired = jobData?.data()?.qualityCheck

  if (userType === userTypes.DATAENTRY_USER) {
    if (isVerifyRequired) {
      status = constants.boxStatus.readyForVerification
    } else {
      if (isQualityCheckRequired) {
        status = constants.boxStatus.readyForQc
      } else {
        status = constants.boxStatus.approved
      }
    }
  } else if (userType === userTypes.DATAENTRY_AND_VERIFY_USER || userType === userTypes.VERIFICATION_USER) {
    if (isQualityCheckRequired) {
      status = constants.boxStatus.readyForQc
    } else {
      status = constants.boxStatus.approved
    }
  }
  return status
}

export const populateSlashOnDate = (keyCode, value) => {
  // if keycode not of backspace and delete
  if (keyCode !== 8 && keyCode !== 46) {
    const numChars = value.length
    let newValue = value
    if (numChars === 2 && value[1] !== '/') {
      return newValue += '/'
    }
    if (numChars === 4) {
      const strArr = value.split('/')
      if (strArr[1]?.length === 2 && value[3] !== '/') {
        return newValue += '/'
      }
    }
    if (numChars === 5 && (value[3] !== '/' && value[4] !== '/')) {
      return newValue += '/'
    }
    if (numChars > 1 && newValue[numChars - 1] === '/' && newValue[numChars - 2] === '/') {
      return newValue.slice(0, numChars - 1)
    }
  }
  // if keycode of backspace
  if (keyCode === 8) {
    const numChars = value.length
    const newValue = value

    if (numChars === 3 || numChars === 6) {
      return newValue.slice(0, numChars - 1)
    }
  }
  return false
}

export const validateDate = (dateString, format) => {
  const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/
  const match = dateString.match(datePattern)
  if (!match) return false
  let day, month, year
  if (format === 'MM/DD/YYYY') {
    month = parseInt(match[1], 10)
    day = parseInt(match[2], 10)
    year = parseInt(match[3], 10)
  } else if (format === 'DD/MM/YYYY') {
    day = parseInt(match[1], 10)
    month = parseInt(match[2], 10)
    year = parseInt(match[3], 10)
  } else {
    return false
  }
  // Check month
  if (month < 1 || month > 12) return false
  // Check day
  const daysInMonth = [31, (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  if (day < 1 || day > daysInMonth[month - 1]) return false
  return true
}

// AI code start — QC grid from/to date comparison using template customFormat
export const getFieldDateFormat = (fields, fieldName, fallback = defaultDateFormat2) => {
  const field = fields?.find((f) => f.name === fieldName)
  return field?.customFormat || fallback
}

export const getDateFormatFromFields = (fields, fromFieldName = 'fromDate', toFieldName = 'toDate') => {
  const fromField = fields?.find((field) => field.name === fromFieldName)
  const toField = fields?.find((field) => field.name === toFieldName)
  return fromField?.customFormat || toField?.customFormat || defaultDateFormat2
}

export const isFromDateAfterToDate = (fromDate, toDate, fromFormat, toFormat) => {
  if (!fromDate || !toDate || !fromFormat) {
    return false
  }
  const resolvedToFormat = toFormat || fromFormat
  const from = moment(fromDate, fromFormat, true)
  const to = moment(toDate, resolvedToFormat, true)
  if (!from.isValid() || !to.isValid()) {
    return false
  }
  return from.isAfter(to)
}
// AI code end
